module.exports = __webpack_public_path__ + "img/silver-indicator.c8078257.png";